import api from './api';

export const getPropertyClassesApi = (params) => api().get('/options-property-classes', { params });
export const addNewPropertyClasseApi = (data) => api().post('/options-property-classes', data);
export const deletePropertyClassesApi = (params) => api().delete('/options-property-classes', { params });
export const updatePropertyClassesApi = (params) => api().put(`/options-property-classes/${params.id}`, params.values);
